import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import CustomModel from "../ADICustomModal";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import React, { ChangeEventHandler, useEffect, useState } from "react";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import { CreditCardDtoCollection, GetSavedCreditCardsModel } from "@NA/Services/SavedCreditCardsService";
import translate from "@insite/client-framework/Translate";
import ADICreditCardView from "./ADICreditCardView";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { ThemeProps, css, withTheme } from "styled-components";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import Radio from "@NA/MobiusOverrides/Radio";

export interface ADIGetCreditCardModalStyle {
    radioListGroup?: RadioGroupProps;
    radioListWrapper?: GridContainerProps;
    radioListLinksGridItem?: GridItemProps;
    rightLinks?: LinkPresentationProps;
    sectionBorder?: InjectableCss;
    pagination?: PaginationPresentationProps;
    sectionErrorMsg?: InjectableCss; //----P21 Changes
    editLinks?: LinkPresentationProps;
}

export const adiGetCreditCardModalStyle: ADIGetCreditCardModalStyle = {
    radioListWrapper: {
        offsetCss: css`
            width: 100%;
            max-width: 100%;
            flex-basis: 100%;
            margin: auto;
            ${GridItemStyle} {
                padding-left: 0;
                padding-right: 0;
            }
        `,
        css: css`
            display: "flex";
            align-items: center;
        `,
    },
    radioListGroup: {
        css: css`
            display: "flex";
            align-items: center;
        `,
    },
    radioListLinksGridItem: {
        css: css`
            justify-content: end;
        `,
    },
    rightLinks: {
        css: css`
            padding: 0 8px 0 0;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            font-weight: bold;
            cursor: pointer;
            :hover {
                text-decoration: underline ${getColor("primary")};
            }
        `,
    },
    sectionBorder: {
        css: css`
            width: 100%;
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },

    sectionErrorMsg: {
        css: css`
           color: ${getColor("danger")} ;
           font-size: ${getProp("theme.typography.headerSecondary.size")};
        `
    },
    editLinks: {
        css: css`
            width: 70% !important;
            max-width: 70% !important;
            padding: 0 8px 0 0;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            font-weight: bold;
            cursor: pointer;
            :hover {
                text-decoration: underline ${getColor("primary")};
            }
        `,
    },
};

interface OwnProps {
    savedCard: GetSavedCreditCardsModel;
    isGetCardOpen: boolean;
    closeGetCard: Function;
    selectedSavedCardId: string;
    handleCardChange: ChangeEventHandler<HTMLInputElement>;
    onChangePage: (newPageIndex: number) => void;
    setEditCard: Function;
    removeCard: Function;
    filterCardType: (key: string) => string;
    //---P21 Change as per new requirement for CC
    newCard: boolean;
    IsRemoved: boolean;
}

const styles = adiGetCreditCardModalStyle;

type Props = OwnProps & ThemeProps<BaseTheme>;

const ADIGetCreditCardModal = ({
    theme,
    savedCard,
    isGetCardOpen,
    closeGetCard,
    selectedSavedCardId,
    setEditCard,
    removeCard,
    handleCardChange,
    onChangePage,
    filterCardType,
    newCard,
    IsRemoved,
}: Props) => {

    const [ccErrorMsg , setccErrorMessage] = useState("");
    // check expiry date
    // const checkExpirationDate = (month: any, year: any) => {
    //     var d = new Date();
    //     month = parseInt(month);
    //     year = parseInt(d.getFullYear().toString().substring(0, 2) + year);
    //     if (year == d.getFullYear() && month < d.getMonth() + 1) {
    //         return true;
    //     }

    //     if (year < d.getFullYear()) {
    //         return true;
    //     }

    //     return false;
    // };

    const checkExpirationDate = (month: any, year: any) => {
        var d = new Date();
        month = parseInt(month);
        year = year.length == 2 ? parseInt(d.getFullYear().toString().substring(0, 2) + year) : year;
        if (year == d.getFullYear() && month < (d.getMonth() + 1)) {
            return true;
        }

        if (year < d.getFullYear()) {
            return true;
        }

        return false;
    }

    //to handle CC error ----P21 Change
    useEffect(() => {
        if(IsRemoved == false)
            setccErrorMessage("* There was an error while processing your request.");
        else if (IsRemoved == true)
            setccErrorMessage("");
    }, [IsRemoved]);

 // modified below method ---P21 Change
    const handleRemoveCard = (item : CreditCardDtoCollection, index : number) => {
        removeCard(item, index).then(() => { 
            if (savedCard.creditCardDtoCollection?.length === 0) {
                closeGetCard();
            }
        });
    };



    
    return (
        <CustomModel
            headline={"Credit Cards on File"}
            subheading="* Please select the card."
            isOpen={isGetCardOpen}
            handleClose={closeGetCard}
            errorStyle={false}
        >
           
            <>

            {IsRemoved == false && (
                <StyledWrapper {...styles.sectionErrorMsg}>{ccErrorMsg}</StyledWrapper>
           )}
                <RadioGroup
                    name="type"
                    {...styles.radioListGroup}
                    value={selectedSavedCardId}
                    onChangeHandler={handleCardChange}
                >
                    {savedCard &&
                        savedCard.creditCardDtoCollection.map((item, index) => {
                            return (
                                <>
                                    <GridContainer key={item.id} {...styles.radioListWrapper}>
                                            <GridItem width={8}>
                                                <Radio
                                                  disabled={checkExpirationDate(item.expiryMonth, item.expiryYear)}
                                                    value={`${item.id}`}
                                                    title={`${item.id}|${item.cardType}|${item.expiryMonth}|${item.expiryYear}`}
                                                    key={`creditCard_${index}`}
                                                >
                                                    {/* <ADICreditCardView item={item} filterCardType={filterCardType} newCard={newCard}/> */}
                                                </Radio>
                                                <ADICreditCardView item={item} filterCardType={filterCardType} newCard={newCard}/>
                                                
                                        </GridItem>
                                        <GridItem width={4} {...styles.radioListLinksGridItem}>
                                            <Link
                                                onClick={() => setEditCard(item.id, "fromGetCCModal",index)}
                                                {...styles.editLinks}
                                            >
                                                {translate("Edit")}
                                            </Link>
                                            <Link
                                                onClick={() =>
                                                    handleRemoveCard(
                                                        item,
                                                        index,
                                                    )
                                                }
                                                {...styles.rightLinks}
                                            >
                                                {translate("Remove")}
                                            </Link>
                                        </GridItem>
                                    </GridContainer>
                                    {savedCard.creditCardDtoCollection.length !== index + 1 && (
                                        <StyledWrapper {...styles.sectionBorder}></StyledWrapper>
                                    )}
                                </>
                            );
                        })}

                    {savedCard && savedCard?.pagination && savedCard.pagination.numberOfPages > 1 && (
                        <Pagination
                            theme={theme}
                            {...styles.pagination}
                            currentPage={savedCard.pagination.currentPage}
                            resultsPerPage={savedCard.pagination.pageSize}
                            resultsCount={savedCard.pagination.totalItemCount}
                            resultsPerPageOptions={[]}
                            onChangePage={onChangePage}
                            onChangeResultsPerPage={() => {}}
                        />
                    )}
                </RadioGroup>
            </>
        </CustomModel>
    );
};

export default withTheme(ADIGetCreditCardModal);
